import { RootState } from "../../../redux-store";

export const selectIsOpen = (state: RootState) =>
  state.app.equipmentDepotDialog.open;

export const selectInitialFormData = (state: RootState) =>
  state.app.equipmentDepotDialog.initialFormData;
